import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=3643d9b2&scoped=true"
import script from "./SelectBox.vue?vue&type=script&lang=js"
export * from "./SelectBox.vue?vue&type=script&lang=js"
import style0 from "./SelectBox.vue?vue&type=style&index=0&id=3643d9b2&prod&scoped=true&lang=css"
import style1 from "./SelectBox.vue?vue&type=style&index=1&id=3643d9b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643d9b2",
  null
  
)

export default component.exports